// extracted by mini-css-extract-plugin
module.exports = {"ResetPasswordByEmail":"ResetPasswordByEmail___ZoXct","section-email":"section-email___1mSRx"};